// Incrementally parses a streamed JSON list such as [{"tone": "Funny"}, ...], returning each
// object as soon as it is complete. Tolerates text before the list and braces inside strings.
export class JsonListParser {
  constructor() {
    this.text = "";
    this.position = 0;
    this.started = false;
    this.finished = false;
    this.depth = 0;
    this.inString = false;
    this.escaped = false;
    this.objectStart = -1;
  }

  push(chunk) {
    this.text += chunk;
    const items = [];
    while (this.position < this.text.length && !this.finished) {
      const char = this.text[this.position];
      if (!this.started) {
        if (char === "[") this.started = true;
      } else if (this.inString) {
        if (this.escaped) this.escaped = false;
        else if (char === "\\") this.escaped = true;
        else if (char === '"') this.inString = false;
      } else if (char === '"') {
        this.inString = true;
      } else if (char === "{") {
        if (this.depth === 0) this.objectStart = this.position;
        this.depth += 1;
      } else if (char === "}") {
        this.depth -= 1;
        if (this.depth === 0 && this.objectStart !== -1) {
          try {
            items.push(
              JSON.parse(this.text.slice(this.objectStart, this.position + 1))
            );
          } catch {
            // Skip anything malformed and carry on with the next item
          }
          this.objectStart = -1;
        }
      } else if (char === "]" && this.depth === 0) {
        this.finished = true;
      }
      this.position += 1;
    }
    return items;
  }
}

export function parseJsonList(text) {
  return new JsonListParser().push(text);
}
